import { Icon } from '@iconify/react'
import { Select } from '@/components/Select'
import {
  MONITORING_INTERVAL_OPTIONS,
  parseMonitoringInterval,
  type MonitoringIntervalSeconds,
} from '@/lib/monitoring-panel'
import styles from './MonitoramentoPage.module.css'

interface MonitoringSettingsProps {
  value: MonitoringIntervalSeconds
  disabled?: boolean
  loading: boolean
  refreshing: boolean
  paused: boolean
  onChange: (value: MonitoringIntervalSeconds) => void
  onCheckNow: () => void
}

const INTERVAL_OPTIONS = MONITORING_INTERVAL_OPTIONS.map((seconds) => ({
  value: String(seconds),
  label: `A cada ${seconds}s`,
}))

export function MonitoringSettings({
  value,
  disabled,
  loading,
  refreshing,
  paused,
  onChange,
  onCheckNow,
}: MonitoringSettingsProps) {
  const liveLabel = paused ? 'Pausado (aba em segundo plano)' : refreshing ? 'Atualizando...' : 'Ao vivo'

  return (
    <aside className={styles.settings} aria-label="Configurações de atualização">
      <p className={styles.settingsTitle}>Atualização automática</p>
      <p className={styles.settingsLive} data-state={paused ? 'paused' : refreshing ? 'refreshing' : 'live'}>
        {liveLabel}
      </p>
      <Select
        label="Intervalo"
        icon="mdi:timer-outline"
        value={String(value)}
        disabled={disabled}
        options={INTERVAL_OPTIONS}
        onChange={(next) => onChange(parseMonitoringInterval(next))}
      />
      <button
        type="button"
        className={styles.checkButton}
        onClick={onCheckNow}
        disabled={disabled || loading}
      >
        <Icon icon={loading ? 'mdi:loading' : 'mdi:refresh'} aria-hidden />
        {loading ? 'Verificando...' : 'Verificar agora'}
      </button>
    </aside>
  )
}
